import { SetProduct } from 'features/product-info/types';

export function getSortedProducts(data: SetProduct[]) {
  if (!data?.length) return [];

  return data.slice().sort((a, b) => {
    if (a.data.eligibility?.webEligible === b.data.eligibility?.webEligible) {
      return 0;
    }

    return a.data.eligibility?.webEligible ? 1 : -1;
  });
}
